import { searchAdjustmentSchema } from '../searchRules'
import { z } from 'zod'
import typeguard from '../typeguard'


import { productMagazineReferenceSchema, productsPreviewSchema } from './product'
import {
  filterTreeSchema,
  filterBrandsSchema,
} from './filterTree'
import { menuPageBuilderSchema } from '../dbTypes/menuPageBuilder'
import { landingPageShopSettingsSchema } from '../dbTypes/landingPageSettings'
import { landingPageImageAiGeneratedSchema } from '../apiBackendResponses/landingPageSettings'
export { landingPageImageAiGeneratedSchema } from '../apiBackendResponses/landingPageSettings'
export type LandingPageImageAiGenerated = z.infer<typeof landingPageImageAiGeneratedSchema>


const filterProductsSchema = z.object({
  products: productsPreviewSchema,
  count: z.number(),
  filterTree: filterTreeSchema.optional(),
  filterBrands: filterBrandsSchema.optional(),
})
export type filterProducts = z.infer<typeof filterProductsSchema>
export const isFilterProducts = typeguard<filterProducts>(filterProductsSchema)


const brandSchema = z.object({
  id: z.number().optional(),
  titel: z.string(),
  path: z.string().optional(),
  logo: z.string().optional(),
  description: z.string().optional(),
  metaTitle: z.string().optional(),
  metaDescription: z.string().optional(),
  metaKeywords: z.string().optional(),
  pageBuilder: menuPageBuilderSchema.optional(),
  magazines: z.array(productMagazineReferenceSchema).optional(),
})
export type brand = z.infer<typeof brandSchema>


const menuSchema = z.object({
  id: z.number().optional(),
  titel: z.string(),
  path: z.string().optional(),
  description: z.string().optional(),
  metaTitle: z.string().optional(),
  metaDescription: z.string().optional(),
  metaKeywords: z.string().optional(),
  sale: z.boolean().optional(),
  stock: z.boolean().optional(),
  onlyStock: z.boolean().optional(),
  pageBuilder: menuPageBuilderSchema.optional(),
  magazines: z.array(productMagazineReferenceSchema).optional(),
})
export type menu = z.infer<typeof menuSchema>

const brandSuggestionSchema = z.object({
  id: z.number(),
  titel: z.string(),
  path: z.string(),
  logo: z.string().optional(),
})
export type brandSuggestion = z.infer<typeof brandSuggestionSchema>

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
/* Responses */

const filterProductsResponseSchema = z.object({
  filterProducts: filterProductsSchema,
  brand: brandSchema.optional(),
  brandSuggestion: brandSuggestionSchema.optional(),
  menu: menuSchema.optional(),
  sitePageBuilder: menuPageBuilderSchema.optional(),
  shopSettings: landingPageShopSettingsSchema.optional(),
  landingPageImageAiGenerated: landingPageImageAiGeneratedSchema.optional(),
  searchSuggestions: z.array(z.string()).optional(),
  searchAdjustment: searchAdjustmentSchema.optional(),
})
export type filterProductsResponse = z.infer<typeof filterProductsResponseSchema>
export const isFilterProductsResponse = typeguard<filterProductsResponse>(filterProductsResponseSchema)

const searchPreviewResponseSchema = z.object({
  filterProducts: z.object({ products: productsPreviewSchema, count: z.number().optional() }),
  brandSuggestion: brandSuggestionSchema.optional(),
  searchSuggestions: z.array(z.string()).optional(),
  searchAdjustment: searchAdjustmentSchema.optional(),
})
export type searchPreviewResponse = z.infer<typeof searchPreviewResponseSchema>
export const isSearchPreviewResponse = typeguard<searchPreviewResponse>(searchPreviewResponseSchema)

const filterMetadataResponseSchema = z.object({
  filterMetadata: z.object({
    filterTree: filterTreeSchema.optional(),
    filterBrands: filterBrandsSchema.optional(),
  }),
})
export type filterMetadataResponse = z.infer<typeof filterMetadataResponseSchema>
export const isFilterMetadataResponse = typeguard<filterMetadataResponse>(filterMetadataResponseSchema)

/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
